module.exports = __webpack_public_path__ + "static/media/ios-shuffle.76b84ba5.svg";